module.exports = __webpack_public_path__ + "assets/de0579958250d3002af7d88498a9d1c5.icon-calendar.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/icon-calendar.svg
 ** module id = 318
 ** module chunks = 1
 **/